import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import useStyles from "./styles";

interface Props {
  title?: string;
  children: React.ReactNode;
  hideTitleOnXS?: boolean;
}

const TitledContainer = (props: Props) => {
  const { hideTitleOnXS = false, title = "", children } = props;
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={hideTitleOnXS ? classes.hideOnDownSm : ""}>
        <Typography className={classes.title}>{title}</Typography>
      </Box>
      <Box className={classes.content}>{children}</Box>
    </Box>
  );
};

export default TitledContainer;
